import React from 'react';
import styled, { css } from 'styled-components';

import { ContentContainer } from '@/modules/SollersHome/common.styles';
import { useSollersHomeData } from '@/modules/SollersHome/hooks';
import { ServiceFormSecondary } from '@/components/LandingWidgets';
import { media } from '@/utils/mixin';
import { ServiceFormSecondaryFields } from '@/components/LandingWidgets/components/ServiceFormSecondary/types';
import { submitSollersCarsLeadForm } from '@/services/leads/leads-service';
import { googleEvent } from '@/utils/events';
import { getDealersOptions } from '@/utils/common';

function Form() {
  const {
    formTitle,
    formSubtitle,
    formImage,
    formMobileImage,
    formButtonTitle,
    formGoogleEvent,
    dealersRequests,
  } = useSollersHomeData();

  if (!formTitle || !formImage) {
    return null;
  }

  const sendServiceForm = async (
    values: ServiceFormSecondaryFields
  ): Promise<void> => {
    try {
      await submitSollersCarsLeadForm({
        ...values,
        model: undefined,
        dealer: values.dealer?.value,
      }).then(() => {
        if (formGoogleEvent) {
          googleEvent(formGoogleEvent);
        }
      });
    } catch (error: any) {
      return Promise.reject(error);
    }
  };

  return (
    <Component id="form">
      <ContentContainer>
        <ServiceFormSecondary
          title={formTitle}
          subtitle={formSubtitle ?? ''}
          image={formImage}
          buttonTitle={formButtonTitle ?? ''}
          imageMobile={formMobileImage}
          fieldsConfig={{ dealers: getDealersOptions(dealersRequests) }}
          onSubmit={sendServiceForm}
        />
      </ContentContainer>
    </Component>
  );
}

export default Form;

const Component = styled.section`
  padding: 30px 0;

  ${media.tablet(css`
    padding: 20px 0;
  `)}
`;
